import { Location } from 'history'
import React from 'react'
import { RouteProps } from 'react-router'
import { Action, AnyAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
// Accounts (family + entity) migrated to the flat route registry (EX-39923,
// supersedes #6986). See flatArchitectureRoutes.tsx + src/page-components/Accounts.
import ActionUnavailableAppRoute from 'src/navigation/appRoutes/actionUnavailable.appRoute'
import AddExpenseAppRoute from 'src/navigation/appRoutes/addExpense.appRoute'
import BillPayAppRoute from 'src/navigation/appRoutes/billPay.appRoute'
import BillPayDetailAppRoute from 'src/navigation/appRoutes/billPayDetail.appRoute'
// Budgets migrated to the flat route registry (EX-39748). See
// flatArchitectureRoutes.tsx + src/page-components/Budgets.
import BulkUploadExpenseLabelsAppRoute from 'src/navigation/appRoutes/bulkUploadExpenseLabels.appRoute'
import CancelSubscriptionAppRoute from 'src/navigation/appRoutes/cancelSubscription.appRoute'
import ChangePasswordAppRoute from 'src/navigation/appRoutes/changePassword.appRoute'
import CloseAccountAppRoute from 'src/navigation/appRoutes/closeAccount.appRoute'
import CloseBillPayCardAppRoute from 'src/navigation/appRoutes/closeBillPayCard.appRoute'
import CloseVirtualCardAppRoute from 'src/navigation/appRoutes/closeVirtualCard.appRoute'
import CreateAutomationRuleAppRoute from 'src/navigation/appRoutes/createAutomationRule.appRoute'
import CreateBillPayAppRoute from 'src/navigation/appRoutes/createBillPay.appRoute'
import CreateBudgetAppRoute from 'src/navigation/appRoutes/createBudget.appRoute'
import CreateVirtualCardAppRoute from 'src/navigation/appRoutes/createVirtualCard.appRoute'
import CspSigninAppRoute from 'src/navigation/appRoutes/cspSignin.appRoute'
import CspUserDetailAppRoute from 'src/navigation/appRoutes/cspUserDetail.appRoute'
import DeactivateBudgetAppRoute from 'src/navigation/appRoutes/deactivateBudget.appRoute'
import ExpensesAppRoute from 'src/navigation/appRoutes/expenses.appRoute'
import OrgExpenseReportAppRoute from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReport.appRoute'
import OrgExpenseReportsHistoricalReportsAppRoute from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReportsHistoricalReports.appRoute'
import HelpAppRoute from 'src/navigation/appRoutes/help.appRoute'
import HomeAppRoute from 'src/navigation/appRoutes/home.appRoute'
import InvitePeopleAppRoute from 'src/navigation/appRoutes/invitePeople.appRoute'
import ManageOrgInviteAppRoute from 'src/navigation/appRoutes/manageOrgInvite.appRoute'
import ManageTrustedDevicesAppRoute from 'src/navigation/appRoutes/manageTrustedDevices.appRoute'
import MyWalletAppRoute from 'src/navigation/appRoutes/myWallet.appRoute'
import MyWalletReimbursementAppRoute from 'src/navigation/appRoutes/myWallet/myWalletReimbursement.appRoute'
import MyWalletVirtualCardDetailAppRoute from 'src/navigation/appRoutes/myWallet/myWalletVirtualCardDetail.appRoute'
import ManageOrgIntegrationAppRoute from 'src/navigation/appRoutes/organization/manageOrgIntegration.appRoute'
import PeopleAppRoute from 'src/navigation/appRoutes/people.appRoute'
import PeopleInvitedToOrgDetailAppRoute from 'src/navigation/appRoutes/peopleInvitedToOrgDetail.appRoute'
import PeopleMembersDetailAppRoute from 'src/navigation/appRoutes/peopleMembersDetail.appRoute'
// Profile family migrated to the flat route registry (EX-39748). Profile
// overlays remain below in popup routes.
import RegisterAccountAppRoute from 'src/navigation/appRoutes/registerAccount.appRoute'
import RegisterOrganizationAppRoute from 'src/navigation/appRoutes/registerOrganization.appRoute'
import RemoveUserFromOrganizationAppRoute from 'src/navigation/appRoutes/removeUserFromOrganization.appRoute'
import ReportingAppRoute from 'src/navigation/appRoutes/reporting.appRoute'
import RequestBudgetAppRoute from 'src/navigation/appRoutes/requestBudget.appRoute'
import RequestVirtualCardAppRoute from 'src/navigation/appRoutes/requestVirtualCard.appRoute'
import ResetPasswordAppRoute from 'src/navigation/appRoutes/resetPassword.appRoute'
import ScreenVirtualCardAppRoute from 'src/navigation/appRoutes/screenVirtualCard.appRoute'
import SearchAppRoute from 'src/navigation/appRoutes/search.appRoute'
import SetOrgExpenseReportCycleAppRoute from 'src/navigation/appRoutes/setOrgExpenseReportCycle.appRoute'
import ShareBillPayVirtualCardAppRoute from 'src/navigation/appRoutes/shareBillPayVirtualCardAppRoute'
import SigninAppRoute from 'src/navigation/appRoutes/signin.appRoute.tsx'
import SignupAppRoute from 'src/navigation/appRoutes/signup.appRoute'
import TransactionDetailAppRoute from 'src/navigation/appRoutes/transactionDetail.appRoute'
import UpdateAutomationRuleAppRoute from 'src/navigation/appRoutes/updateAutomationRule.appRoute'
import UpdateBillPayVirtualCardAppRoute from 'src/navigation/appRoutes/updateBillPayVirtualCard.appRoute'
import UpdateBudgetAppRoute from 'src/navigation/appRoutes/updateBudget.appRoute'
import UpdateBudgetRequestAppRoute from 'src/navigation/appRoutes/updateBudgetRequest.appRoute'
import UpdateBulkTransactionsAppRoute from 'src/navigation/appRoutes/updateBulkTransactions.appRoute'
import UpdateExpenseAppRoute from 'src/navigation/appRoutes/updateExpense.appRoute'
import UpdateProfilePhotoAppRoute from 'src/navigation/appRoutes/updateProfilePhoto.appRoute'
import UpdateVirtualCardAppRoute from 'src/navigation/appRoutes/updateVirtualCard.appRoute'
import UpgradeSubscriptionAppRoute from 'src/navigation/appRoutes/upgradeSubscription.appRoute'
import UserScreeningInfoAppRoute from 'src/navigation/appRoutes/userScreeningInfo.appRoute'
import VirtualCardsAppRoute from 'src/navigation/appRoutes/virtualCards.appRoute'
export {
  AuthenticatedFlatArchitectureRoutes,
  PublicFlatArchitectureRoutes,
} from 'src/navigation/flatArchitectureRoutes'
import {
  authenticationAgnosticRouteProps,
  baseRouteProps,
} from 'src/navigation/routeProps'
/* HYGEN-INJECT-IMPORT */
import { RootState } from 'src/redux/createRootReducer'

import { AppLocation, SidenavContentType } from './appLocations'
import SsoCallbackAppRoute from './appRoutes/ssocallback.appRoute'
import VirtualCardDetailAppRoute from './appRoutes/virtualCardDetail.appRoute'

export interface AppRoute<A extends Action = AnyAction> {
  id?: AppLocation
  routeProps: RouteProps // used to match against
  component?: React.ReactElement
  fetch?: (location: Location) => ThunkAction<Promise<void>, RootState, void, A>
  exceptions?: Array<AppRoute<A>>
  subRoutes: Array<AppRoute<A>>
  meta?: {
    // TODO: make not optional
    contentType?: SidenavContentType // TODO: | undefined
  }
}

export const authenticationAgnosticAppRoute: AppRoute = {
  routeProps: authenticationAgnosticRouteProps, // needs to be specific to allow authed/unauthed to swap on everything else
  subRoutes: [],
}

export const authedBackgroundAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    HomeAppRoute,
    VirtualCardDetailAppRoute,
    VirtualCardsAppRoute,
    MyWalletVirtualCardDetailAppRoute,
    MyWalletReimbursementAppRoute,
    MyWalletAppRoute,
    ReportingAppRoute,
    PeopleAppRoute,
    ExpensesAppRoute,
    BillPayDetailAppRoute,
    BillPayAppRoute,
    // EX-39748 — the organization-settings routes (expense categories + labels,
    // departments + details, integrations, business rules, reimbursements, org
    // info, subscription, API keys, automation, SSO, card feeds, custom-field /
    // department detail) were migrated to the flat route registry
    // (flatArchitectureRoutes.tsx + OrganizationSettingsPage). Their appRoute
    // objects are retained (imported by OrganizationSettingsPage) but are no
    // longer registered in this legacy background tree.
    OrgExpenseReportsHistoricalReportsAppRoute,
    OrgExpenseReportAppRoute,
  ],
}

export const authedPopupAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    ScreenVirtualCardAppRoute,
    // DeactivateVirtualCard/BillPayCard are query-param overlays (?modal=deactivate),
    // rendered in Authed via useModalRoute — see modalParams.ts.
    DeactivateBudgetAppRoute,
    RegisterAccountAppRoute,
    UpdateProfilePhotoAppRoute,
    UpgradeSubscriptionAppRoute,
    UserScreeningInfoAppRoute,
    ActionUnavailableAppRoute,
    RegisterOrganizationAppRoute,
    ManageOrgInviteAppRoute,
    ManageOrgIntegrationAppRoute,
    RemoveUserFromOrganizationAppRoute,
    ChangePasswordAppRoute,
    ManageTrustedDevicesAppRoute,
    CloseVirtualCardAppRoute,
    CloseBillPayCardAppRoute,
    CloseAccountAppRoute,
    SetOrgExpenseReportCycleAppRoute,
    ShareBillPayVirtualCardAppRoute,
    CancelSubscriptionAppRoute,
  ],
}

export const authedLeftFlyoutAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [HelpAppRoute, SearchAppRoute, CspUserDetailAppRoute],
}

export const authedRightFlyoutAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    CreateVirtualCardAppRoute,
    RequestVirtualCardAppRoute,
    UpdateVirtualCardAppRoute,
    CreateBudgetAppRoute,
    RequestBudgetAppRoute,
    UpdateBudgetAppRoute,
    UpdateBudgetRequestAppRoute,
    TransactionDetailAppRoute,
    PeopleMembersDetailAppRoute,
    PeopleInvitedToOrgDetailAppRoute,
    InvitePeopleAppRoute,
    AddExpenseAppRoute,
    UpdateExpenseAppRoute,
    UpdateBulkTransactionsAppRoute,
    CreateBillPayAppRoute,
    UpdateBillPayVirtualCardAppRoute,
    CreateAutomationRuleAppRoute,
    UpdateAutomationRuleAppRoute,
    BulkUploadExpenseLabelsAppRoute,
  ],
}

export const unauthedAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    SigninAppRoute,
    SignupAppRoute,
    ResetPasswordAppRoute,
    CspSigninAppRoute,
    SsoCallbackAppRoute,
  ],
}

// UNUSED
export const rootAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    authedBackgroundAppRoute,
    authedPopupAppRoute,
    authedLeftFlyoutAppRoute,
    authedRightFlyoutAppRoute,
    unauthedAppRoute,
  ],
}
